import Gameboard from './Gameboard'
import './App.css'

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <Gameboard />
    </div>
  )
}

export default App